import { SkeletonProps } from "@mui/material";
import React from "react";
import { cn } from "@RHCommerceDev/utils/cn";

interface ISkeletonProps {
  id?: string;
  variant?: SkeletonProps["variant"];
  width?: string | number;
  height?: string | number;
  animation?: "pulse" | "wave" | false;
  className?: string;
  style?: React.CSSProperties;
}

export const TailwindSkeleton: React.FC<ISkeletonProps> = ({
  id = "",
  variant = "text",
  width,
  height,
  animation = "pulse",
  className = "",
  style = {},
  ...rest
}) => {
  const baseClasses = "bg-[#EBE7DF]";
  const variantClasses =
    variant === "text"
      ? "transform scale-x-100 scale-y-[60%] rounded my-0 origin-x-0 origin-y-[60%]"
      : variant === "rectangular"
      ? "rounded-md"
      : "rounded-full";
  const animationClasses =
    animation === "pulse"
      ? "animate-pulse"
      : animation === "wave"
      ? "bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 animate-wave"
      : "";

  return (
    <span
      className={cn(
        "block h-[1.43em] w-full",
        baseClasses,
        variantClasses,
        animationClasses,
        className
      )}
      id={id}
      data-testid={"tailwind-skeleton"}
      style={{
        ...(height && { height: height }),
        ...(width && { width: width }),
        ...(style && { ...style })
      }}
      {...rest}
    ></span>
  );
};

export default TailwindSkeleton;

export * from "./TextSkeleton";
export * from "./TwoColumnsSkeleton";
